module.exports = __webpack_public_path__ + "img/icon-swchuti-logo.a791c1fb.png";